import { Route, Routes } from 'react-router-dom';
import PriceSimulationDetailContainer from '../../../Containers/Settings/PriceSimulation/PriceSimulationDetailContainer';

export default function PriceSimulationLayout() {
    return (
        <Routes>
            <Route index element={<PriceSimulationDetailContainer />} />
        </Routes>
    );
}
